import { render, staticRenderFns } from "./CreateEditNews.vue?vue&type=template&id=03fe61a4"
import script from "./CreateEditNews.vue?vue&type=script&lang=js"
export * from "./CreateEditNews.vue?vue&type=script&lang=js"
import style0 from "./CreateEditNews.vue?vue&type=style&index=0&id=03fe61a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports